var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContent)?_c('div',{attrs:{"id":"app"}},[(!_vm.hideHeader)?_c('XHeader'):_vm._e(),_c('div',{staticClass:"container"},[_c('router-view')],1),_c('GoService'),_c('CookiePolicy'),(!_vm.hideFooter)?_c('XFooter'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }